<template>
  <div class="context">
    <p class="title">APIリファレンス</p>
    <div v-for="item in items" :key="item.number" class="box">
      <p class="item subtitle">
        {{ item.subtitle }}
      </p>
      <p class="item content" v-html="item.content"></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          number: 0,
          subtitle: "提供している機能",
          content:
            "山梨県にて保有するオープンデータを、オープンソースソフトウェアのFIWARE Orion Context Brokerを利用してNGSIv2形式で取得することが可能となります。",
        },
        {
          number: 1,
          subtitle: "APIの利用にあたって",
          content:
            "APIの利用には、API利用規約が適用され、APIを利用するとAPI利用規約に同意したものとみなされます。",
        },
        {
          number: 2,
          subtitle: "仕様",
          content: `本APIはFIWARE Orion Context Brokerを用いて構築しているため、本APIへのリクエストはOrion Context Brokerの仕様に準拠した形で実施ください。
          Orion Context Brokerについては<a href='https://fiware-orion.readthedocs.io/en/master/'>こちら</a>の公式ドキュメントをご確認ください。
          また、APIリファレンスにつきましては、<a href='https://swagger.lab.fiware.org/'>こちら</a>よりご確認ください。
          以下の項目については、認証など本API固有の情報についてご記載させていただきます。
          また、具体的なサンプルコードについて、<a href='/developer-portal/sample-code'>こちら</a>にて掲載をしていますのでご確認ください。`,
        },
        {
          number: 3,
          subtitle: "API認証",
          content:
            "本APIではOpenID Connectによる認証を実施しています。<br>いただいた利用申請ごとにアプリケーション固有のIDおよびパスワードを払い出しさせていただき、それらの情報を用いてクライアント・クレデンシャルズフローによる認証を実施いただくことで本APIへのアクセスが可能となります。<br>なお、アクセストークンの有効期限は300秒となります。",
        },
        {
          number: 4,
          subtitle: "アクセス制御の考え方",
          content: "前述のAPI認証を用いてアクセス制御を実施しています。",
        },
        {
          number: 5,
          subtitle: "使用するプロトコル",
          content: "HTTPS",
        },
        {
          number: 6,
          subtitle: "ベースURI",
          content: `[ APIエンドポイント ]
          https://api.dataplatform-yamanashi.jp/ngsi

          [ 認証エンドポイント ]
          https://idm.dataplatform-yamanashi.jp`,
        },
        {
          number: 8,
          subtitle: "利用開始にあたり",
          content:
            "事前に<a href='/developer-portal/howtouse'>こちら</a>より申請ください。",
        },
        {
          number: 7,
          subtitle: "リクエストヘッダ（認証エンドポイント）",
          content: `認証エンドポイントにトークンリクエストする場合には、以下のリクエストヘッダが必要です。

<table style="font-size:1.2vw; width: 100%;">
<tr>
<th align="left">ヘッダ</th>
<th align="left">説明</th>
</tr>
<tr>
<td>Authorization</td>
<td>"Basic "を付与し、利用者ごとに発行されるクライアントIDと
クライアント・シークレットを:で繋げた文字列を
Base64エンコードした文字列</td>
</tr>`,
        },
        {
          number: 8,
          subtitle: "リクエストヘッダ（APIエンドポイント）",
          content: `APIエンドポイントにリクエストする場合には、以下の共通リクエストヘッダが必要です。

<table style="font-size:1.2vw; width: 100%;">
<tr>
<th align="left">ヘッダ</th>
<th align="left">説明</th>
</tr>
<tr>
<td>Authorization</td>
<td>"Bearer "を付与し、認証エンドポイントより取得した
アクセストークンを利用</td>
</tr>`,
        },
      ],
    };
  },
};
</script>

<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 4%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.item {
  font-size: 1.4vw;
}

.box {
  margin-bottom: 4vw;
}

.subtitle {
  font-weight: 700;
  margin-bottom: 1vw;
}

.content {
  padding: 0 0 0 4%;
  white-space: pre-line;
}
</style>
